import React, { useId } from "react";
import "./ServiceRoleEditor.css";

interface ServiceRoleEditorProps {
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSave: () => void;
  onCancel?: () => void;
  saving?: boolean;
  disabled?: boolean;
  saveLabel?: string;
  children?: React.ReactNode;
}

export default function ServiceRoleEditor({ name, description, onNameChange,
  onDescriptionChange, onSave, onCancel, saving = false, disabled = false,
  saveLabel = "Add role", children }: ServiceRoleEditorProps) {
  const id = useId();
  return <div className="service-role-editor-control">
    <div className="service-role-form">
      <div className="form-group">
        <label className="form-label" htmlFor={`${id}-name`}>Role name</label>
        <input id={`${id}-name`} className="form-input" value={name} autoFocus
          onChange={(event) => onNameChange(event.target.value)} disabled={saving || disabled}
          placeholder="e.g. Session leader" />
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor={`${id}-description`}>Description</label>
        <input id={`${id}-description`} className="form-input" value={description}
          onChange={(event) => onDescriptionChange(event.target.value)} disabled={saving || disabled}
          placeholder="Optional description" onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              if (name.trim() && !saving && !disabled) onSave();
            }
          }} />
      </div>
    </div>
    {children}
    <div className="service-role-form__actions">
      <button type="button" className="action-button compact" onClick={onSave}
        disabled={saving || disabled || !name.trim()}>{saving ? "Saving..." : saveLabel}</button>
      {onCancel && <button type="button" className="action-button compact secondary"
        onClick={onCancel} disabled={saving}>Cancel</button>}
    </div>
  </div>;
}
